import {FC, ReactNode} from "react";
import {css, cx} from "@pandacss/css";

interface Props {
    children: ReactNode,
    open?: boolean,
    size?: number
}

const bottomSheetClass = css({
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    transform: "translateY(100%)",
    transition: "transform 0.3s ease-in-out",
    backgroundColor: "neutral.800",
    border: "1px solid",
    borderColor: "neutral.500",
    borderTopRightRadius: "16px",
    borderTopLeftRadius: "16px",
    padding: '16px',
    zIndex: "9999",
    display: 'flex',
    flexDirection: 'column',

    "&.open": {
        transform: "translateY(0)"
    }
})

const bottomSheetHandleClass = css({
    position: "absolute",
    top: "4px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "48px",
    height: "4px",
    backgroundColor: "neutral.300",
    borderRadius: "2px"
})


const BottomSheet: FC<Props> = ({open, children, size}) => {
    return <div className={cx(bottomSheetClass, open ? 'open' : '')} style={{ height: size }}>
        <div className={bottomSheetHandleClass}></div>
        {children}
    </div>
}

export default BottomSheet